'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.default = function (cart) {
    setTimeout(function () {
        var data = {
            'ecomm_prodid': (0, _stringify2.default)(cart.items.map(function (m) {
                return m.productId;
            })),
            'ecomm_pagetype': 'cart',
            'ecomm_totalvalue': cart.totalProductsPrice.finalPriceWithoutVat,
            'category_name': (0, _stringify2.default)(cart.items.filter(function (i) {
                return i.details && i.details.genre && i.details.genre.category && i.details.genre.category.name;
            }).map(function (m) {
                return (0, _kebabCase2.default)(m.details.genre.category.name);
            }))
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);
    }, 500);
};

var _kebabCase = require('lodash/kebabCase');

var _kebabCase2 = _interopRequireDefault(_kebabCase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/gtm.js
// module id = 1152
// module chunks = 0